import React from 'react';
const GuideLines = ({ dimensions, position, lineProps, hideHorizontal, hideVertical }) => {
    if (!lineProps)
        lineProps = {};
    return (React.createElement(React.Fragment, null,
        !hideVertical && (React.createElement("line", Object.assign({ x1: position.x, x2: position.x, y1: 0, y2: dimensions.height, stroke: "#000000", strokeWidth: 1 }, lineProps))),
        !hideHorizontal && (React.createElement("line", Object.assign({ x1: 0, x2: dimensions.width, y1: position.y, y2: position.y, stroke: "#000000", strokeWidth: 1 }, lineProps)))));
};
export default GuideLines;
